module.exports = __webpack_public_path__ + "static/media/1.f0929fe0.jpg";